export const coordinatorPath = {
  'verzoeken': ['/verzoeken/overzicht', '/verzoeken/planbord', "/verzoeken/indienen","/verzoeken/planscreen",],
};

export const melderPath = {
  'verzoeken': ['/verzoeken', "/indienen", "/verzoeken/:substitutionId/dagdelen-toevoegen"],
};

export const reiskostenPath = {
  'reiskosten': ['/reiskosten','/reiskosten/afstanden', '/reiskosten/berekenen'],
};

export const weekstatenPath = {
  'weekstaten': ['/weekstaten'],
};